import { EvacZoneStatus } from 'shared/types';

export const statusSortingComparator = (
  a?: EvacZoneStatus,
  b?: EvacZoneStatus,
): number => {
  const statusOrder: EvacZoneStatus[] = [
    'orders',
    'warnings',
    'advisories',
    'shelter_in_place',
  ];
  const indexA = statusOrder.indexOf(a ?? ('' as EvacZoneStatus));
  const indexB = statusOrder.indexOf(b ?? ('' as EvacZoneStatus));
  const posA = indexA === -1 ? statusOrder.length : indexA;
  const posB = indexB === -1 ? statusOrder.length : indexB;
  return posA - posB;
};
